<template>
  <div class="match">
    <div class="filter_icon">
      <v-icon color="white" @click="bottomSheet = 'search_settings'">search</v-icon>
    </div>

    <div
      id="overlay"
      class="blur-overlay"
      v-if="
        (user_data.swipesLeft <= 0 && $store.state.showPaymentsBlock) ||
        (unlimitedPackageIsActive && !unlimitedPackageIsValid)
      "
    >
      <div v-animate-css="'fadeIn'" class="premium-card-wrapper">
        <div class="premium-card">
          <div class="pay-header">
            <h2 class="text-xs-center">SWIPE-PACKAGES</h2>
            <p>
              <b
                >Mit den Swipe-Packages kannst du weitere Vereine connecten und somit
                deinen Traumverein finden - umso mehr Swipes du zur Verfügung hast,
                desto größer ist deine Chance.</b
              >
            </p>
          </div>
          <StripePayment />
        </div>
      </div>
    </div>

    <template v-else>
      <div
        class="blur-overlay"
        v-if="
          user_data.swipesLeft <= 0 ||
          (unlimitedPackageIsActive && !unlimitedPackageIsValid)
        "
        @click="$store.state.buy_swipes_dialog = true"
      ></div>
      <div class="free_swipes_wrapper">
        <span class="potential-matches mb-1">
          DU HAST AKTUELL <b>{{ visibleCards.length }}</b> POTENZIELLE MATCHES
        </span>
        <br />
        <v-chip v-if="unlimitedPackageIsActive" small class="free-swipes mt-3">
          VERFÜGBARE SWIPES:&nbsp;<b>{{ unlimitedPackageValidDays }} Tage</b>
        </v-chip>
        <v-chip v-else small class="free-swipes mt-3">
          VERFÜGBARE SWIPES:&nbsp;<b>{{ user_data.swipesLeft }}</b>
        </v-chip>
      </div>

      <v-card class="no-results" v-if="visibleCards.length < 1">
        <img src="@/assets/icons/no_result.png" alt />
        <div v-if="!loading">
          <h2 class="text-xs-center">Leider kein Treffer.</h2>
          <p>Passe deine Filter zur Vereinssuche in der oberen Ecke an.</p>
        </div>
      </v-card>

      <GameCardsStack
        v-else
        :class="['gamecards']"
        :cards="visibleCards"
        @cardAccepted="handleCardAccepted"
        @cardRejected="handleCardRejected($event, 'trainers')"
        @cardSkipped="handleCardSkipped"
        @hideCard="removeCardFromDeck"
        @moreInfos="moreInfos"
      />
    </template>

    <MatchSheetTeam
      v-if="visibleCards.length"
      :selectedProfile="visibleCards[visibleCards.length - 1]"
      @close="team_infos = false"
      :show="team_infos"
      :showMatchButtons="false"
    ></MatchSheetTeam>

    <TrainerSearchTeam
      :show="bottomSheet !== 'hidden'"
      :showSaveButton="true"
      @save-and-close="saveSettings"
    />

    <div v-if="visibleCards.length > 0 && !user_data.swipesLeft <= 0" class="moreinfos">
      <div class="">* Verein wird für 90 Tage ausgeblendet.</div>
      <v-btn @click="moreInfos" class="menu-button main main-xsmall thin">
        Zum Vereinsprofil
        <!-- <v-icon color="green white--text" @click="moreInfos">info</v-icon> -->
      </v-btn>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import _ from 'lodash';
import { mapState } from 'vuex';
import { db } from '@/db';
import GameCardsStack from '@/components/GameCardsStack';
import MatchSheetTeam from '@/components/match/TeamSheet';
import TrainerSearchTeam from '@/components/home/TrainerSearchTeam';
import matchPlayerTrainer from '../../mixins/match-player-trainer';
import StripePayment from '../payment/StripePayment';

export default {
  name: 'match-trainers',

  components: {
    GameCardsStack,
    MatchSheetTeam,
    TrainerSearchTeam,
    StripePayment,
  },

  data() {
    return {
      team_infos: false,
      bottomSheet: 'hidden',
      stackAnimation: {
        classes: 'zoomIn',
        delay: 300,
        duration: 400,
      },
    };
  },

  mixins: [matchPlayerTrainer],

  computed: {
    ...mapState(['user_data', 'visibleCards', 'loading', 'payments']),
  },

  methods: {
    moreInfos() {
      this.team_infos = true;
    },

    saveSettings() {
      db.collection('trainers')
        .doc(this.user_data.id)
        .update({ ...this.user_data })
        .then(() => {
          this.setCards();
          this.bottomSheet = 'hidden';
        });
    },
    checkIfDocExsits(snapshot, id) {
      if (snapshot.exists) {
        // Return all the old applications
        const doc = snapshot.data();
        if (typeof doc.trainer_applications === 'undefined') {
          db.collection('teams').doc(id).update({ trainer_applications: [] });
          return;
        }
        const oldApplications = doc.trainer_applications;
        return oldApplications;
      }
      db.collection('teams').doc(id).set({ trainer_applications: [] });
      return [];
    },

    applyForTeam(id) {
      if (this.user_data.swipesLeft <= 0) {
        return;
      }
      db.collection('teams')
        .doc(id)
        .get()
        .then((snapshot) => this.checkIfDocExsits(snapshot, id))
        .then((oldApplications) =>
          db
            .collection('teams')
            .doc(id)
            .update({
              trainer_applications: [...oldApplications, this.$store.state.user_id],
              newApplication: {
                id: this.user_data.id,
                type: 'trainers',
              },
            })
            .then(() => {
              this.sendPushMessage('teams', id);
            }),
        )
        .then(() => {
          this.$store.state.user_data.swipesLeft = this.user_data.swipesLeft - 1;
          if (!this.user_data.applied_teams) {
            this.$store.state.user_data.applied_teams = [];
          }
          this.user_data.applied_teams.push(id);

          db.collection('trainers').doc(this.user_data.id).update({
            swipesLeft: this.user_data.swipesLeft,
            applied_teams: this.user_data.applied_teams,
          });
        })
        .catch((e) => {});
    },

    setCards() {
      this.$store.state.loading = true;
      const swipedIDs = this.getActiveTeamIds(90);

      db.collection('teams')
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs
            .map((doc) => doc.data())
            // .filter(team => team.id === 'S6LxQGZRfEXwWYMpe7T4txsGf0V2' || team.id === '0ugn2q9EhXMXdzKws8Lj7s3noRk1');
            // Filter teams without a Name
            .filter((team) => team.team_name !== '')
            .filter((team) => team.category)
            .filter((team) => {
              if (team.will_be_found_by && team.will_be_found_by.includes('Trainer')) {
                return team;
              }
            })
            .filter((team) => !swipedIDs.includes(team.id))
            .filter((team) => {
              if (team.trainerprofile_type && this.user_data.trainer_type) {
                return team.trainerprofile_type.includes(this.user_data.trainer_type);
              }
            })
            .filter((team) =>
              team.trainerprofile_sex
                ? team.trainerprofile_sex.includes(this.user_data.sex)
                : false,
            )
            // Filter teams with selected nationality
            .filter((team) => team.nationality === this.user_data.search_nationality)
            .filter((team) => {
              if (!this.user_data.verband_filter) {
                return true;
              }
              if (!team.verband || !this.user_data.search_verband) {
                return false;
              }
              return team.verband === this.user_data.search_verband;
            })
            // Filter teams that are not in selected league
            .filter((team) => {
              if (!this.user_data.verband_filter) {
                return team;
              }
              if (Array.isArray(this.user_data.search_league)) {
                return this.user_data.search_league.includes(team.category.league);
              }
              return this.user_data.search_league === team.category.league;
            })
            .filter((team) => {
              if (!this.user_data.applied_teams) {
                return team;
              }
              return !this.user_data.applied_teams.includes(team.id);
            });
          const result = _.sortBy(documents, (team) => team.category.category);
          return result;
        })
        .then((documents) => {
          this.$store.state.loading = false;
          this.$store.state.visibleCards = documents;
        });
    },
  },
  beforeMount() {
    // Prevent Cards from Bugging by removing the Scroll for the Match Screen
    document.documentElement.style.overflow = 'hidden';
  },
  mounted() {
    if (this.user_data.userType !== 'trainer') {
      this.$router.push({ name: 'dummyHome' });
    }

    if (!this.visibleCards.length) {
      this.setCards();
    } else {
      this.$store.state.loading = false;
    }

    this.overlay = document.getElementById('overlay');
    this.overlay.addEventListener(
      'touchstart',
      (event) => {
        if (event.targetTouches.length === 1) {
          // detect single touch
          this.clientY = event.targetTouches[0].clientY;
        }
      },
      false,
    );

    this.overlay.addEventListener(
      'touchmove',
      (event) => {
        if (event.targetTouches.length === 1) {
          // detect single touch
          this.disableRubberBand(event);
        }
      },
      false,
    );
  },

  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/index.scss';
.blur-overlay {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  height: 100%;
  // padding-bottom: 70px;
  overflow-y: scroll;
  width: 100vw;
  background: rgba(255, 255, 255, 0.5);
  z-index: 199;
  -webkit-overflow-scrolling: touch;
}
.premium-card-wrapper {
  width: 90vw;
  min-height: 40vh;
  max-width: 500px;
  z-index: 11;
  padding: 15px;
  border-radius: 10px;
  height: 100%;
  margin-bottom: 60px;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.premium-card {
  width: 100%;
  border-radius: 8px;
  box-shadow: 2px 3px 3px 2px rgba(0, 0, 0, 0.25);
  background-color: white;
}

.match {
  height: 100vh;
  overflow: hidden;
  padding-bottom: 20vh;
  // width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.filter_icon {
  right: 20px;
  top: 20px;
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: 0px;
  color: white;
  height: 50px;
  width: 50px;
  @include mainLinearGradient;
  border-bottom-left-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
}
.card {
  margin-top: 20px;
  height: 300px;
  width: 300px;
  background: white;
  border-radius: 20px;
}

.gamecards {
  height: 420px;
}

.closeBtn {
  @include closeBtn;
}
.save-button {
  @include mainLinearGradient;
  position: fixed;
  bottom: -100vh;
  left: 50%;
  transform: translateX(-50%);
  height: 40px;
  margin: auto;
  margin-bottom: 40px;
}
.menu-button {
  border-radius: 50px;
  width: 90%;
  max-width: 200px;
}

.white {
  color: white;
}

.active {
  top: 0;
}
.activeBtn {
  position: fixed;
  bottom: 2vh !important;
}

.v-select {
  width: 100%;
}
.v-text-field {
  width: 100%;
}

.settings {
  padding: 15px;
  margin-top: 50px;
  display: flex;
  align-items: flex-start;
  text-align: left;
  flex-direction: column;
  padding-bottom: 100px;

  .input {
    width: 100%;
    max-width: 400px;
  }
}

label {
  margin-top: 20px;
}

.no-results {
  img {
    width: 80%;
    max-width: 170px;
    margin: auto;
  }

  width: 100%;
  border-radius: 10px;
  padding: 15px;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  z-index: 0;
}

.btn-arrow {
  position: fixed;
  right: 10px;
  top: 45px;
  z-index: 1;
  animation: updown 1s infinite linear;
}

@keyframes updown {
  0% {
    top: 45px;
  }
  50% {
    top: 50px;
  }
  100% {
    top: 45px;
  }
}

.moreinfos {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100px;
  width: 100%;
  text-align: center;

  div {
    font-size: 11px;
    color: red;
  }
}
</style>
